<template>
  <div class="main">
    <div class="background">
      <img class="background-image cloud-l" src="../assets/course/cloud_left.png" alt="">
      <img class="background-image cloud-r" src="../assets/course/cloud_right.png" alt="">
      <div class="book-index container-fluid">
        <div class="row">
          <div class="group-box">
            <div class="title-box">
              Completed Story
            </div>
            <div class="line"></div>
            <div class="content-box ">
              <div class="select-box mt-3">
                <div class="d-flex align-items-center justify-content-between py-2">
                  <div class="d-flex align-items-stretch">
                    <div class="class-tile mr-2">
                      <div class="title">
                        Class
                      </div>
                      <!-- <p class="warning">請選擇分校名稱</p> -->
                    </div>
                    <select class="area-select" v-model="selected">
                      <option disabled value="0">Please select one</option>
                      <option v-for="(item) in groupList" :key="item.id" :value="item.id">{{item.name}}</option>
                    </select>
                  </div>
                  <div>
                    <button type="button" @click="downloadExcel()" class="btn btn-primary mx-1">Export</button>
                  </div>
                </div>
              </div>
              <div class="table-box py-3 p-2">
                <table class="rwd-table">
                  <tbody>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Account</th>
                      <th>ID</th>
                      <th>Book Open</th>
                      <th>Book Complete</th>
                      <th>Rate</th>
                      <th>Check</th>
                    </tr>
                    <tr v-for="(item, index) in studentList" :key="index">
                      <td data-th="No.">
                        {{ index + (pageIndex - 1) * pageSize + 1 }}
                      </td>
                      <td data-th="Name">
                        {{ item.name }}
                      </td>
                      <td data-th="Account">
                        {{ item.account }}
                      </td>
                      <td data-th="ID">
                        {{ fixRole(item.role) }}
                      </td>
                      <td data-th="Book Open">
                        {{ item.total_count }}
                      </td>
                      <td data-th="Book Complete">
                        {{ item.completed_count }}
                      </td>
                      <td data-th="Rate">
                        {{ Math.ceil(item.completion_rate) }} %
                      </td>
                      <td class="pointer check-btn" data-th="Check" @click="goBook( item.id )">
                        Book
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '../components/Pagination.vue'
import { mapGetters, mapActions } from 'vuex'
import api from '../store/api'

export default {
  name: 'Teacher',
  data () {
    return {
      groupList: [],
      studentList: [],
      selected: 0,
      pageIndex: 1,
      pageSize: 10,
      pageCount: 10
    }
  },
  watch: {
    selected (val) {
      this.getStudent()
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    // this.getBookIndex()
    this.getGroups()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    async getGroups () {
      const { data } = await api.get('AIStorybook/groups?pageSize=1000')
      this.groupList = data.data
      this.selected = data.data[0].id
    },
    async getStudent () {
      const { data } = await api.get(`AIStorybook/groups/${this.selected}/students?page=${this.pageIndex}&pageSize=${this.pageSize}`)
      this.studentList = data.data
      this.pageCount = data.pageCount
    },
    // async downloadExcel (item) {
    //   const { data } = await api.get(`AIStorybook/reports/${this.selected}`)
    //   console.log(data)
    // },
    async downloadExcel () {
      const vm = this
      try {
        const response = await api.get(
          `AIStorybook/reports/${vm.selected}`,
          { responseType: 'blob' }
        )

        if (response && response.data) {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          const fileName = `Excel_${vm.selected}.xlsx`

          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        } else {
          throw new Error('無回傳資料')
        }
      } catch (error) {
        console.error('Excel 證書下載失敗 ❌', error)
      }
    },
    goBook (id) {
      this.$router.push({ name: 'Book_Index', params: { studentId: id } })
    },
    openFileInput () {
      this.$refs.fileInput.click()
    },
    // download (el) {
    //   window.open(`https://ll-livespeaking.liveabc.com/AIStorybook/reader/${el.view_id}/download`, '_blank')
    // },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getStudent()
    },
    fixRole (text) {
      switch (text) {
        case 'user':
          return 'Student'
        default:
          return 'Teacher'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    .background {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      background-color: blue;
      background: linear-gradient(to bottom, rgb(57, 57, 248) 0%, rgb(94, 92, 252) 100%);
      z-index: 10;
      .background-image {
        position: fixed;
        bottom: 0;
        z-index: -5;
      }
      .cloud-l {
        left: 0;
      }
      .cloud-r {
        right: 0;
      }
    }
    .book-index {
      margin: 20vh 10vw 10vh 10vw;
      width: 60vw;
      min-height: 80vh;
      border: 10px solid orangered;
      border-radius: 30px;
      background-color: #fff;
      padding: 5vh 5vw;

      .boxSizing{
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box;    /* Firefox, other Gecko */
        box-sizing: border-box;         /* Opera/IE 8+ */
      }
      .group-box {
        width: 100%;
      }
      .line {
        width:100%;
        height:4px;
        background-color:#1a55dd;
      }
      .title-box {
        width: 150px;
        padding: 10px 3px;
        color: #cee0ff;
        border-radius: 5px 5px 0 0;
        background-color: #1a55dd;
      }
      .content-box {
        position: relative;
        width:100%;
        min-height: 30vh;
        border-left:1px #cee0ff solid;
        border-right:1px #cee0ff solid;
        border-bottom:1px #cee0ff solid;
        background-color:#f4f4f4;
        border-bottom-left-radius:10px;
        border-bottom-right-radius:10px;
        overflow: hidden;
        .select-box {
          padding: 20px 30px 20px 20px;
          background-color: #cee0ff;
          position: relative;
        }
        .class-tile {
          .title {
            padding: 4px;
            border-radius:2px;
            background-color:#527fff;
            color:#FFF !important;
          }
        }
        .area-select {
          width: 200px;
          border:1px #527fff solid;
          padding:3px;
          padding-left:8px;
          padding-right:8px;
        }
        .remind-box {
          position: absolute;
          color: red;
          left: 50%;
          top: 70%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
    }
    .table-box {
      min-height: 30vh;
    }
    .check-btn {
      color: #1552fa;
      text-decoration: underline;
    }
    @media screen and (max-width: 1480px) {
      .cloud-l {
        display: none;
      }
      .cloud-r {
        display: none;
      }
      .book-index {
        width: 80vw;
        .title-book {
          padding: 10% 0px;
        }
      }
    } /*小於750*/
  }
  .rwd-table {
    margin: auto;
    min-width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    font-size: 1.1rem;
  }

  .rwd-table tr:first-child {
    border-top: none;
    background: #258d00;
    color: #fff;
  }
  th {
    border-left: 1px solid #33cc33 !important;
  }
  .rwd-table th:first-child>td:first-child {
    border-left: 1px solid #33cc33;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #f5f9fc;
  }
  .rwd-table tr:nth-child(even):not(:first-child) {
    background-color: #ebf3f9;
  }
  .rwd-table tr:nth-child(odd):not(:first-child) {
    background-color: #fff;
  }
  .rwd-table th {
    display: none;
  }
  .rwd-table td {
    display: block;
  }
  .rwd-table td:first-child {
    margin-top: .5em;
  }
  .rwd-table td:last-child {
    margin-bottom: .5em;
  }
  .rwd-table td:before {
    content: attr(data-th) "： ";
    font-weight: bold;
    display: inline-block;
    color: #000;
  }
  .rwd-table tr {
    border-color: #bfbfbf;
  }
  .rwd-table th,
  .rwd-table td {
    height: 3em;
    padding: .5em 1em;
  }
  @media screen and (max-width: 601px) {
    .rwd-table tr {
      border-top: none;
      border: 1px solid #258d00;
    }
    .rwd-table th,
    .rwd-table td {
      text-align: left  !important;
    }
  }
  @media screen and (min-width: 600px) {
    .rwd-table tr:hover:not(:first-child) {
      background-color: #d8e7f3;
    }
    .rwd-table td:before {
      display: none;
    }
    .rwd-table th,
    .rwd-table td {
      display: table-cell;
      padding: .25em .5em;
    }
    .rwd-table th:first-child,
    .rwd-table td:first-child {
      padding-left: 0;
    }
    .rwd-table th:last-child,
    .rwd-table td:last-child {
      padding-right: 0;
    }
  }

</style>
